import { Controller } from "stimulus";
import Choices from "choices.js";

export default class extends Controller {
  static targets = ["field"];
  static values = {
    shouldSort: Boolean,
    searchDisabled: Boolean,
    noRemoveItemButton: Boolean
  };

  connect() {
    const fieldInput = this.fieldTarget;

    const choicesInstance = new Choices(fieldInput, {
      itemSelectText: 'Select',
      removeItemButton: !this.noRemoveItemButtonValue, // TODO #3135
      shouldSort: this.shouldSortValue ?? true,
      searchEnabled: !this.searchDisabledValue, // TODO #3135
      searchResultLimit: 100,
      fuseOptions: {
        threshold: 0.1, // 0.0 = exact match, 1.0 = match anything. Default is 0.6
      }
    });
    // Store the instance on the element for external access
    fieldInput.choicesInstance = choicesInstance;
  }
}
